import { el, onTap } from './dom.ts';
import { lang, setLang, t, type Lang } from '../i18n/index.ts';
import { resolve } from '../router.ts';

// Dil seçici. İki küçük düğme (TR / EN); seçim bu cihazda saklanır ve ekran
// yerinde yeniden çizilir (rota yeniden çözülür, adres değişmez).
//
// Kabukta (landing üst çubuğu, giriş ekranı, ayarlar, yasal sayfa) kullanılır;
// oynatıcı açıkken dil değişmez — oynatma kesilmesin.

export function langSwitch(variant: 'inline' | 'block' = 'inline'): HTMLElement {
  const current = lang();
  const make = (code: Lang, label: string) => {
    const button = el('button', {
      type: 'button',
      class: code === current ? 'active' : '',
      'aria-pressed': code === current ? 'true' : 'false',
      lang: code,
    }, label);
    onTap(button, () => {
      if (code === lang()) return;
      setLang(code);
      void resolve();
    });
    return button;
  };
  return el('div', { class: `lang-switch ${variant}`, role: 'group', 'aria-label': t('lang.switch') },
    make('tr', variant === 'block' ? t('lang.tr') : 'TR'),
    make('en', variant === 'block' ? t('lang.en') : 'EN'),
  );
}
